"use strict";

exports.__esModule = true;
exports.Footer = Footer;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FooterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Footer__FooterWrapper",
  componentId: "sc-1jqlx3h-0"
})(["display:flex;flex:0 0 48px;width:100%;overflow:hidden;padding:8px 9px 8px 18px;margin:0;color:", ";background:", ";height:48px;justify-content:space-between;"], (0, _Theme.val)("FootTextColor"), (0, _Theme.val)("FooterBackground"));
var LeftContent = _styledComponents["default"].div.withConfig({
  displayName: "Footer__LeftContent",
  componentId: "sc-1jqlx3h-1"
})(["display:flex;flex-direction:row;justify-content:flex-start;flex:1;"]);
var RightContent = _styledComponents["default"].div.withConfig({
  displayName: "Footer__RightContent",
  componentId: "sc-1jqlx3h-2"
})(["display:flex;flex-direction:row;justify-content:flex-end;flex:1;"]);

/**
 * Displays Footer.
 */

function Footer(_ref) {
  var leftContent = _ref.leftContent,
    rightContent = _ref.rightContent;
  return /*#__PURE__*/_react["default"].createElement(FooterWrapper, null, /*#__PURE__*/_react["default"].createElement(LeftContent, null, leftContent), /*#__PURE__*/_react["default"].createElement(RightContent, null, rightContent));
}